import type { TemplateFn } from "./index";
import { ROOT_TARGET, baseTimeline } from "./_helpers";
import type { Effect } from "../ir";

// Wave-sweep proxy: scaleY breathing + Y-offset that "settles" creates the
// fluid feel without an actual SVG mask animation (which would require
// per-logo path data we don't have).
export const liquidReveal: TemplateFn = (ir, logo) => {
  const base = baseTimeline(ir, logo);
  return {
    ...base,
    effects: [{ kind: "liquid" as Effect, intensity: 0.55 }, ...ir.effects].slice(0, 4),
    tracks: [{
      target: ROOT_TARGET,
      easing: "easeInOutCubic",
      delay: 0,
      keyframes: [
        { t: 0.00, opacity: 0, scaleY: 0.4, scaleX: 1.1, y: 24, filter: "blur(4px)" },
        { t: 0.30, opacity: 0.7, scaleY: 1.12, scaleX: 0.95, y: -6 },
        { t: 0.55, opacity: 1, scaleY: 0.94, scaleX: 1.03, y:  3, filter: "blur(0px)" },
        { t: 0.78, scaleY: 1.02, scaleX: 0.99, y: -1 },
        { t: 1.00, opacity: 1, scaleY: 1,    scaleX: 1,    y:  0 },
      ],
    }],
  };
};
